import { Check, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuickInfoBadge {
  key: string;
  label: string;
  status: 'success' | 'pending' | 'failed';
}

interface ShipmentQuickInfoProps {
  badges: readonly QuickInfoBadge[] | QuickInfoBadge[];
  className?: string;
}

export function ShipmentQuickInfo({ badges, className }: ShipmentQuickInfoProps) {
  const getStatusStyles = (status: QuickInfoBadge['status']) => {
    switch (status) {
      case 'success':
        return 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800';
      case 'failed':
        return 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800';
      case 'pending':
      default:
        return 'bg-yellow-100 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-800';
    }
  };

  const getStatusIcon = (status: QuickInfoBadge['status']) => {
    switch (status) {
      case 'success':
        return <Check className="h-3.5 w-3.5" />;
      case 'failed':
        return <X className="h-3.5 w-3.5" />;
      case 'pending':
      default:
        return null;
    }
  };

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {badges.map((badge) => (
        <div
          key={badge.key}
          className={cn(
            "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border",
            getStatusStyles(badge.status)
          )}
        >
          {getStatusIcon(badge.status)}
          <span>{badge.label}</span>
        </div>
      ))}
    </div>
  );
}
